module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-1.43b51ca6.jpg";